import Mock from 'mockjs'
import { param2Obj } from 'src/utils'
import {course_name, agent_name, publish_name, class_name, college, campus} from './datas';
import {random} from 'lodash';

const List = []
const count = 100

for (let i = 0; i < count; i++) {
  const bookPrice = Mock.Random.float(0, 100, 2, 2);
  const bookingNumber = Mock.Random.integer(1,300);
  List.push(Mock.mock({
    id: '@increment',
    book_name: '@ctitle(4,8)',
    book_author: '@cname',
    book_isbn: '@guid',
    'publish_name|1': publish_name,
    book_price: bookPrice,
    'agency_name|1': agent_name,
    booking_number: bookingNumber,
    total_price: (bookPrice * bookingNumber).toFixed(2),
    'course_name|1': course_name,
    class_teacher: '@cname',
    'class_name|1': class_name,
    class_total: '@integer(0, 58)',
    teacher_use_book_total: '@integer(0, 5)',
    book_approve: '@boolean',
    teacher_book_use_approve: '@boolean',
    choose_status: '@boolean',
    'college_name|1': college,
    'campus_name|1': campus,
    created_at: +Mock.Random.date('T')
  }))
}

const collegeList = [];
for (let j = 0; j < count; j++) {
  const children = [];
  for (let k = 0; k < random(2, 8); k++) {
    if(j % 2 === 0){
      children.push(Mock.mock({
        'course_name|1': course_name,
        'class_name|4-6': [{
          'name|+1': class_name,
          'status': '@boolean'
        }],
        'teacher_name': '@cname',
        'teacher_concat_number|13310126065-17706512667': 0,
        'status': false
      }))
    } else {
      children.push(Mock.mock({
        'course_name|1': course_name,
        'class_name|4-6': [{
          'name|+1': class_name,
          'status': true
        }],
        'teacher_name': '@cname',
        'teacher_concat_number|13310126065-17706512667': 0,
        'status': true
      }))
    }

  }
  collegeList.push(Mock.mock({
    id: '@increment',
    'college_name|1': college,
    'contacts_person': '@cname',
    'contacts_number|13310126065-17706512667': 13310126065,
    children,
    urge_total: '@integer(1,10)',
    created_at: +Mock.Random.date('T')
  }))
}

export default {
  getList: config => {
    const { choose_status, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = List.filter(item => {

      if (choose_status !== undefined && item.choose_status !== !!+choose_status) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  },
  getPv: () => ({
    pvData: [{ key: 'PC', pv: 1024 }, { key: 'mobile', pv: 1024 }, { key: 'ios', pv: 1024 }, { key: 'android', pv: 1024 }]
  }),
  getArticle: () => ({
    id: 120000000001,
    author: { key: 'mockPan' },
    source_name: '原创作者',
    category_item: [{ key: 'global', name: '全球' }],
    comment_disabled: true,
    content: '<p>我是测试数据我是测试数据</p><p><img class="wscnph" src="https://wpimg.wallstcn.com/4c69009c-0fd4-4153-b112-6cb53d1cf943" data-wscntype="image" data-wscnh="300" data-wscnw="400" data-mce-src="https://wpimg.wallstcn.com/4c69009c-0fd4-4153-b112-6cb53d1cf943"></p>"',
    content_short: '我是测试数据',
    display_time: +new Date(),
    image_uri: 'https://wpimg.wallstcn.com/e4558086-631c-425c-9430-56ffb46e70b3',
    platforms: ['a-platform'],
    source_uri: 'https://github.com/PanJiaChen/vue-element-admin',
    status: 'published',
    tags: [],
    title: 'vue-element-admin'
  }),
  createArticle: () => ({
    data: 'success'
  }),
  updateArticle: () => ({
    data: 'success'
  }),
  getOrderByCollege(config){
    const { importance, type, title, page = 1, limit = 20, sort } = param2Obj(config.url)

    let mockList = collegeList.filter(item => {
      if (importance && item.importance !== +importance) return false
      if (type && item.type !== type) return false
      if (title && item.title.indexOf(title) < 0) return false
      return true
    })

    if (sort === '-id') {
      mockList = mockList.reverse()
    }

    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

    return {
      total: mockList.length,
      items: pageList
    }
  }
}



// WEBPACK FOOTER //
// ./src/mock/order.js